import React from "react";
import styled from "styled-components";
import colours from "../../lib/colours";

const StyledCloseButton = styled.button`
  &:focus {
    outline: none;
  }
  background-color: transparent;
  color: ${colours.th1};
  font-size: 22px;
  margin-left: auto;
  cursor: pointer;
  border-color: transparent;
  transition: color 0.35s ease;
  &:hover {
    color: ${colours.th1l2};
  }
`;

interface IProps {
  fontSize?: string;
  onClick: any;
}

class CloseButton extends React.Component<IProps> {
  render() {
    const { fontSize, onClick } = this.props;
    return (
      <StyledCloseButton
        onClick={onClick}
        style={fontSize ? { fontSize } : {}}
        className="btn"
      >
        ✕
      </StyledCloseButton>
    );
  }
}

export default CloseButton;
